import { Component, Input } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { PlaylistItemDTO } from '../../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { Launcher } from '../../../core/models/entities/launcher.type';
import { VideoPreviewComponent } from '../../../shared-module/components/_modals/video-preview/video-preview.component';
import { AppConstants } from '../../../app.constants';

@Component({
  selector: 'item-content-preview',
  standalone: true,
  imports: [],
  templateUrl: './item-content-preview.component.html',
  styleUrl: './item-content-preview.component.scss'
})
export class ItemContentPreviewComponent {
  @Input() item: PlaylistItemDTO;
  @Input() selectedLauncher: Launcher;

  videoTypeRegular = AppConstants.CONTENT_PREVIEW_VIDEO_FILE_TYPES_REGULAR;
  isPreviewLoaded: boolean;

  constructor(private dialog: MatDialog) {}

  showPreview() {
    const dialogRef = this.dialog.open(VideoPreviewComponent, {
      panelClass: 'custom-video-preview-modalbox'
    });
    dialogRef.componentInstance.isVideoPreview = this.isVideoFile();
    dialogRef.componentInstance.item = this.item;
  }

  isVideoFile(): boolean {
    return AppConstants.CONTENT_PREVIEW_VIDEO_FILE_TYPES_REGULAR.test(this.item.PlaylistItemLinks[0].File.Title);
  }
}
